// export function getQuery(query: any): string {

//   var arr = [];
//   for (var property in query) {
//     if (query.hasOwnProperty(property)) {
//       if (query[property] !== 'null' && query[property] !== 'undefined' && query[property] !== undefined && query[property] !== null)
//         arr.push(property + "=" + query[property]);
//     }
//   }

//   return arr.join("&");
// }

export function getQuery(query: any): string {
	const arr: string[] = [];


	for (const property in query) {
		if (!query.hasOwnProperty(property)) continue;

		const value = query[property];

		if (value === null || value === undefined || value === "null" || value === "undefined" || value === "")
			continue;

		if (Array.isArray(value)) {
			if (value.length === 0) continue;

			value.forEach((v, i) => {
				if (v === null || v === undefined || v === "") return;
				arr.push(`${encodeURIComponent(property)}[${i}]=${encodeURIComponent(v)}`);
			});
			continue;
		}
		else {
			arr.push(`${encodeURIComponent(property)}=${encodeURIComponent(value)}`);
		}
		
	}
	console.log(arr.join("&"));
	return arr.join("&");
}